import React from 'react';
import AttributeButton from './attribute-button';

const ATTRIBUTE_NAMES = { BRAND: 'brand', CLOTHES_SIZE: 'clothes_size' };
const ATTRIBUTE_PREFIX = 'af-';

const AttributeButtonsList = ({ attributes, onClick, className }) => {
    const visibleAttributes = attributes
        .map(({ name, values }) => {
            switch (name) {
                case ATTRIBUTE_NAMES.BRAND:
                    return { name, values };
                case ATTRIBUTE_NAMES.CLOTHES_SIZE:
                    return { name: ATTRIBUTE_PREFIX + name, values };
                default:
                    return null;
            }
        })
        .filter(x => !!x);
    return (
        <p className={`item-card-title d-flex flex-row ${className}`}>
            {visibleAttributes.map(attribute => (
                <AttributeButton
                    key={attribute.name}
                    text={attribute.values.join('/')}
                    onClick={() => onClick(attribute)}
                />
            ))}
        </p>
    );
};
export default AttributeButtonsList;
